import NavLogo from './Company Logo.svg'
import ContactSvg1 from './Landing/Frame 133.svg'
import ContactSvg2 from './Landing/Frame 132.svg'
import ContactSvg3 from './Landing/Frame 131.svg'
 
export const Icons = {
   Brand: {
      NavLogo
   },
   Landing: {
      ContactSvg1,
      ContactSvg2,
      ContactSvg3,

   }
}